export enum TYPE_ICON {
    IMG = 'img',
    URL = 'url',
    ICON = 'icon',
}
